import { render, staticRenderFns } from "./MakeupSchedulersPage.vue?vue&type=template&id=c5ba0c34&scoped=true&lang=pug"
import script from "./MakeupSchedulersPage.vue?vue&type=script&lang=js"
export * from "./MakeupSchedulersPage.vue?vue&type=script&lang=js"
import style0 from "./MakeupSchedulersPage.vue?vue&type=style&index=0&id=c5ba0c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ba0c34",
  null
  
)

export default component.exports